import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import BloodGroupForm from '../components/forms/BloodGroupForm';
import '../styles/EmployeeMaster.css';
import BloodGroupTable from '../components/BloodGroupTable';

const BloodGroupEditModel = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const navigate = useNavigate();
     const location = useLocation();
     const { id } = useParams(); // ✅ Get ID from route

     const [bloodGroupData, setBloodGroupData] = useState(null);
     const [loading, setLoading] = useState(false);

     // ✅ Show modal only if URL starts with /bloodgroup/edit
     const showModal = location.pathname.startsWith('/bloodgroup/edit');

     const handleCloseModal = () => {
          navigate('/bloodgroup'); // Go back to list
     };

     // ✅ Fetch Blood Group details by ID
     useEffect(() => {
          if (id && showModal) {
               setLoading(true);
               fetch(`${baseUrl}/getBloodGroupById/${id}`)
                    .then(res => res.json())
                    .then(data => {
                         if (data.status) {
                              setBloodGroupData(data.data);
                         } else {
                              setBloodGroupData(null);
                         }
                         setLoading(false);
                    })
                    .catch(err => {
                         console.error('Error fetching Blood Group by ID:', err);
                         setLoading(false);
                    });
          }
     }, [id, showModal]);

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Blood Group Master</h2>
               </div>

               {/* Table of Blood Groups */}
               <BloodGroupTable />

               {/* Edit Modal */}
               <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
                    <Modal.Header closeButton>
                         <Modal.Title>Edit Blood Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                         {loading ? (
                              <div className="text-center">
                                   <Spinner animation="border" /> Loading...
                              </div>
                         ) : bloodGroupData ? (
                              <BloodGroupForm bloodGroupId={id} initialData={bloodGroupData} /> // ✅ Pass data to form
                         ) : (
                              <p className="text-center">No data found for this Blood Group.</p>
                         )}
                    </Modal.Body>

               </Modal>
          </div>
     );
};

export default BloodGroupEditModel;